import React, { FC } from 'react';

import Button from '../../../../../components/Button';

export type TSectionSelected = 'Leaderboards' | 'OtherAwards';

interface IProps {
  otherAwardsOnClick?: () => void;
  leaderboardsOnClick: () => void;
  sectionSelected: TSectionSelected;
}

export const AssignResultsSectionSelector: FC<IProps> = props => {
  const { sectionSelected, leaderboardsOnClick, otherAwardsOnClick } = props;

  const leaderboardsState = sectionSelected === 'Leaderboards' ? '' : 'in';
  const otherAwardsState = sectionSelected === 'OtherAwards' ? '' : 'in';

  return (
    <div className="assign-awards-section-selector">
      <Button
        classes={{ label: 'list-filter__label' }}
        className={`list-filter list-filter--${leaderboardsState}active list-filter--player`}
        color="primary"
        variant={leaderboardsState === 'in' ? 'outlined' : 'contained'}
        onClick={leaderboardsOnClick}
      >
        LEADERBOARDS
      </Button>

      {otherAwardsOnClick && (
        <Button
          classes={{ label: 'list-filter__label' }}
          className={`list-filter list-filter--${otherAwardsState}active list-filter--player`}
          color="primary"
          variant={otherAwardsState === 'in' ? 'outlined' : 'contained'}
          onClick={otherAwardsOnClick}
        >
          Other awards
        </Button>
      )}
    </div>
  );
};
